export interface CommissionRule {
  id: string;
  cargo: 'CONSULTOR' | 'SUPERVISOR' | 'COORDENADOR' | 'GERENTE';
  faixa_faturamento: number;
  faixa_plus: boolean;
  pn_pct: number;
  ha_pct: number;
  fibra_pct: number;
  tt_pct: number;
  /** TT PRE — % de Totalização pré-paga (TT PRE-PJ). Inicia herdando tt_pct. */
  tt_pre_pct: number;
  /** (Douglas 28/07) % pago sobre faturamento de T.I. (produtos com fat_ti). */
  ti_pct?: number;
  /** (Douglas 28/07) % pago sobre faturamento de Fixa Avançada. */
  avancada_pct?: number;
  mp_pct: number;
  ativo: boolean;
  competencia: string; // 'YYYY-MM-DD'
  vigencia_inicio: string;
  vigencia_fim: string | null;
  usuario_id?: string | null;
  /** Segmento da regra geral: 'PJ' (CNPJ) ou 'PF' (CPF). Sem regra PF no mês, o CPF usa a PJ. */
  tipo_pessoa?: string | null;
  created_at: string;
  updated_at: string;
}

export interface MetaMensal {
  /** Legado sem campo pertence a PJ; PF possui registro explícito por competência. */
  tipo_pessoa?: 'PF' | 'PJ';
  id: string;
  /** NULL quando a meta é individual (usuario_id) ou de equipe (equipe_id). */
  cargo: 'CONSULTOR' | 'SUPERVISOR' | 'COORDENADOR' | 'GERENTE' | null;
  competencia: string; // 'YYYY-MM-DD'
  meta_altas: number;
  meta_fibras: number;
  meta_fat_vn: number;
  meta_fat_total: number;
  meta_qtd_tt: number;
  meta_qtd_mp: number;
  meta_qtd_migracao: number;
  /** (Douglas 28/07) Meta de FATURAMENTO de T.I. em R$ (produtos com fat_ti). */
  meta_fat_ti?: number;
  meta_fat_avancada?: number;
  /** (Douglas 29/08) Meta de SD — QUANTIDADE de licenças (produtos com qtd_sd). */
  meta_sd?: number;
  /** (Douglas 21/10/2026) Meta de TV — QUANTIDADE de TV CPF (produtos com qtd_tv). Só CPF. */
  meta_tv?: number;
  usar_meta_altas: boolean;
  usar_meta_fibras: boolean;
  usar_meta_fat_vn: boolean;
  usar_meta_fat_total: boolean;
  usar_meta_qtd_tt: boolean;
  usar_meta_qtd_mp: boolean;
  usar_meta_qtd_migracao: boolean;
  usar_meta_fat_ti?: boolean;
  usar_meta_fat_avancada?: boolean;
  usar_meta_sd?: boolean;
  usar_meta_tv?: boolean;
  /** (Douglas 26/10/2026) Fibras acima da meta de fibra que validam a Renovação. */
  meta_fibras_renovacao?: number;
  usar_meta_fibras_renovacao?: boolean;
  /** (Douglas 29/10/2026) Regra 3: TT + Renovação juntos (Migração) pagam este %. */
  usar_meta_migracao_junta?: boolean;
  pct_meta_migracao_junta?: number;
  multiplicador_n: boolean;
  ativo: boolean;
  usuario_id?: string | null;
  /** Quando preenchido, a meta vale para todos os consultores desta equipe
   *  (prioridade: individual > equipe > cargo). */
  equipe_id?: string | null;
  created_at: string;
  updated_at: string;
}

export const FAIXAS_FATURAMENTO = [1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000];

// Função helper para encontrar faixa
export function encontrarFaixa(faturamentoTotal: number): number {
  const faixaEncontrada = FAIXAS_FATURAMENTO
    .filter(f => faturamentoTotal >= f)
    .pop();

  return faixaEncontrada || FAIXAS_FATURAMENTO[0];
}

// Função helper para encontrar faixa de supervisor
export function encontrarFaixaSupervisor(
  faturamentoEquipe: number,
  nVendedores: number
): { faixaSupervisor: number; faixaBase: number } {
  const faixasSuper = FAIXAS_FATURAMENTO.map(f => f * nVendedores);
  const faixaSupEncontrada = faixasSuper
    .filter(f => faturamentoEquipe >= f)
    .pop() || faixasSuper[0];

  const indiceFaixa = faixasSuper.indexOf(faixaSupEncontrada);

  return {
    faixaSupervisor: faixaSupEncontrada,
    faixaBase: FAIXAS_FATURAMENTO[indiceFaixa >= 0 ? indiceFaixa : 0]
  };
}
